import ProviderImageThumbnail from "@components/Booking/SlotPicking/components/ProviderImageThumbnail";
import React from "react";
import {formatName} from "src/utils/formatName";

import Details from "./Details";
import Frame from "./Frame";
import ImageFrame from "./ImageFrame";

/**
 * Renders a card that highlights appointment information relevant to a primary care appointment.
 */
const PrimaryCareTile = ({
  imageId,
  time,
  firstName,
  lastName,
  credential,
  street,
  locationTimezone,
}: {
  /**
   * The id of the provider's cover iamge
   */
  imageId?: string | null;
  /**
   * The time of the appointment (epoch ms)
   */
  time: number;
  /**
   * Of the provider
   */
  firstName: string;
  /**
   * Of the provider
   */
  lastName: string;
  /**
   * Of the provider
   */
  credential?: string | null;
  /**
   * The street address (line1) of the relevant clinic location.
   */
  street: string;
  /**
   * The timezone of the relevant clinic location.
   */
  locationTimezone?: string | null;
}) => (
  <Frame>
    <ImageFrame>
      <ProviderImageThumbnail height={56} imageId={imageId} />
    </ImageFrame>
    <Details
      time={time}
      locationTimezone={locationTimezone}
      line2={`${formatName(firstName, lastName, credential)} · ${street}`}
    />
  </Frame>
);

export default React.memo(PrimaryCareTile);
